export default __webpack_public_path__ + "static/media/mas.a3ce20e2.png";